import $ from 'jquery';
import barba from '@barba/core';
//import {createPopper} from '@popperjs/core';
import 'bootstrap';
import {gsap} from "gsap";
import menu from './utils/menu';
import modal from './utils/modal';
import common from './utils/common';
import transitions from './utils/transitions';
import scroll from './utils/scroll';
import createSwiper from './utils/swiper';

import landing from './pages/landing';
import activites from './pages/activites';
import accueil from "./pages/accueil";
import projets from "./pages/projets";
import actualite from "./pages/actualite";
import barcinoHome from "./pages/barcino_home";
import barcinoDiagnostic from "./pages/barcino_diagnostic";
import barcinoHeader from "./parts/barcino_header";
import barcinoSearch from "./parts/barcino_search";
import barcinoRecipeDrawer from "./parts/barcino_recipe_drawer";
import barcinoPhone from "./utils/barcino_phone";
import barcinoCart from "./parts/barcino_cart";
import barcinoProduit from "./pages/barcino_produit";
import barcinoCoffret from "./pages/barcino_coffret";
import barcinoCatalogue from "./pages/barcino_catalogue";
import barcinoPanier from "./pages/barcino_panier";
import barcinoNews from "./pages/barcino_news";
import barcinoCommande from "./pages/barcino_commande";
import barcinoSuivi from "./pages/barcino_suivi";
import barcinoFaq from "./pages/barcino_faq";
import barcinoLegal from "./pages/barcino_legal";
import barcinoTorrefacteurs from "./pages/barcino_torrefacteurs";
import barcinoTorrefacteurDetail from "./pages/barcino_torrefacteur_detail";
import barcinoVision from "./pages/barcino_vision";
import barcinoCookies from "./parts/barcino_cookies";

export const mobile = {state: false};
const _no_scroll = false;

barcinoCookies.init();

// ─── Modal newsletter — globale (footer présent sur toutes les pages) ──────────
// Auto-ouverture 4,5s après le chargement, avec mémorisation navigateur
// (localStorage, donc valable au-delà de la session et sur plusieurs jours) :
// - une fois fermée, elle ne réapparaît pas avant NL_SNOOZE_DAYS jours
// - une fois l'inscription réussie, elle ne réapparaît plus jamais
// Le check "déjà abonné" côté serveur (data-nl-subscribed, users.newsletter_opt_in
// pour un client connecté) prime sur le localStorage.
const NL_AUTO_OPEN_DELAY = 4500;
const NL_SNOOZE_DAYS     = 3;
const NL_STORAGE_SUBSCRIBED     = 'bc_nl_subscribed';
const NL_STORAGE_DISMISSED_UNTIL = 'bc_nl_dismissed_until';

function _nlStorageGet(key) {
    try {
        return window.localStorage.getItem(key);
    } catch {
        return null;
    }
}

function _nlStorageSet(key, value) {
    try {
        window.localStorage.setItem(key, value);
    } catch {
        // localStorage indisponible (navigation privée, etc.) — on ignore
    }
}

function _initNewsletterModal() {
    const modal    = document.getElementById('bc-nl-modal');
    if (!modal) return;

    const form     = modal.querySelector('[data-nl-modal-form]');
    const feedback = modal.querySelector('[data-nl-modal-feedback]');
    const inputEl  = modal.querySelector('input[type="email"]');

    function openModal() {
        modal.classList.add('is-open');
        modal.removeAttribute('aria-hidden');
        modal.inert = false;
        document.body.style.overflow = 'hidden';
        inputEl?.focus();
    }

    function closeModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        modal.inert = true;
        document.body.style.overflow = '';

        // Snooze : ne pas rouvrir automatiquement avant quelques jours,
        // même dans une session ultérieure sur ce même navigateur.
        const until = Date.now() + NL_SNOOZE_DAYS * 24 * 60 * 60 * 1000;
        _nlStorageSet(NL_STORAGE_DISMISSED_UNTIL, String(until));
    }

    // Ouverture depuis n'importe quel trigger de la page courante
    document.addEventListener('nl:open', openModal);

    // Auto-ouverture, sauf si déjà abonné (serveur ou localStorage) ou snoozée
    const alreadySubscribed = modal.dataset.nlSubscribed === '1'
        || _nlStorageGet(NL_STORAGE_SUBSCRIBED) === '1';
    const dismissedUntil = Number.parseInt(_nlStorageGet(NL_STORAGE_DISMISSED_UNTIL) || '0', 10);
    const stillSnoozed = Number.isFinite(dismissedUntil) && dismissedUntil > Date.now();

    if (!alreadySubscribed && !stillSnoozed) {
        window.setTimeout(() => {
            document.dispatchEvent(new CustomEvent('nl:open'));
        }, NL_AUTO_OPEN_DELAY);
    }

    // Déclencheur — délégué au document pour fonctionner sur toutes les pages
    // (bloc newsletter présent partout, avec ou sans Barba)
    document.addEventListener('click', (event) => {
        if (event.target.closest('[data-nl-trigger]')) {
            document.dispatchEvent(new CustomEvent('nl:open'));
        }
    });

    // Fermeture : overlay + bouton close
    modal.querySelectorAll('[data-nl-modal-close]').forEach(el => {
        el.addEventListener('click', closeModal);
    });

    // Fermeture : touche Escape
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    // Soumission Brevo : retour immédiat et protection contre les doubles envois.
    if (!form || !feedback) return;
    let is_submitting = false;
    const result = form.querySelector('[data-nl-modal-result]');
    function show_result(message, state = '') {
        feedback.textContent = message;
        feedback.className = 'bc-nl-modal__feedback ' + state;
        result?.classList.toggle('is-error', state === 'is-error');
        result?.classList.toggle('is-success', state === 'is-success');
        form.classList.add('is-active');
        feedback.focus();
    }
    form.querySelector('[data-nl-modal-retry]')?.addEventListener('click', () => {
        if (is_submitting) return;
        form.classList.remove('is-active');
        inputEl?.focus();
    });

    // Barba annule le clic natif hors lien : déclencher explicitement submit,
    // comme sur le formulaire de suivi de commande (barcino_suivi.js).
    const submit_button = form.querySelector('button[type="submit"]');
    submit_button?.addEventListener('click', (event) => {
        event.preventDefault();
        form.requestSubmit(submit_button);
    });

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (is_submitting) return;
        const email = inputEl?.value.trim();
        if (!email || !inputEl.checkValidity()) {
            show_result(modal.dataset.i18nInvalidEmail, 'is-error');
            return;
        }

        const submitBtn = form.querySelector('button[type="submit"]');
        is_submitting = true;
        if (submitBtn) submitBtn.disabled = true;
        form.setAttribute('aria-busy', 'true');
        show_result(modal.dataset.i18nLoading);
        const abort_controller = new AbortController();
        const timeout_id = window.setTimeout(() => abort_controller.abort(), 45000);

        try {
            const res = await fetch(form.action, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify({ email }),
                signal: abort_controller.signal,
            });
            if (!res.ok) throw new Error('Newsletter HTTP ' + res.status);
            const data = await res.json();
            show_result(data.message || (data.success
                ? modal.dataset.i18nSuccess : modal.dataset.i18nError),
                data.success ? 'is-success' : 'is-error');
            if (data.success) {
                _nlStorageSet(NL_STORAGE_SUBSCRIBED, '1');
                form.reset();
            }
        } catch {
            show_result(modal.dataset.i18nError, 'is-error');
        } finally {
            window.clearTimeout(timeout_id);
            is_submitting = false;
            form.removeAttribute('aria-busy');
            if (submitBtn) submitBtn.disabled = false;
        }
    });
}

// ─── Accordéons du footer — globaux, présents sur toutes les pages ────────────
function _initFooterAccordions() {
    document.addEventListener('click', (event) => {
        const summary = event.target.closest('.bc-footer__accordion-summary');
        if (!summary) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const accordion = summary.closest('.bc-footer__accordion');
        const toggle = accordion?.previousElementSibling;
        if (!accordion || !toggle?.classList.contains('bc-footer__accordion-toggle')) return;

        const isOpen = accordion.classList.toggle('is-open');
        toggle.checked = isOpen;
    }, true);
}


window.onbeforeunload = function () {
    window.scrollTo(0, 0);
};

$(document).ready(function () {


    // Initialisation de common
    common.init();

    // Initialisation de connexion
    //connexion.init();

    // Contrôle de la largeur de la fenêtre
    common.getWINDOW();
    if (common.$windowW < 768) {
        mobile.state = true;
    } else {
        mobile.state = false;
    }

    // Initialisation de menu
    menu.init();

    // Header — global (scroll, mega-menu, hamburger — présent sur toutes les pages)
    barcinoHeader.init();

    // Recherche — global (drawer présent sur toutes les pages)
    barcinoSearch.init();

    // Recettes — global (drawer présent sur toutes les pages)
    barcinoRecipeDrawer.init();

    // Panier — global (toast + compteur sur toutes les pages)
    barcinoCart.init();
    barcinoProduit.init();
    barcinoCoffret.init();

    // Page panier funnel — hors Barba, init uniquement si .bc-panier présent
    barcinoPanier.init();

    // Tunnel de commande - hors Barba, accordéon et sauvegarde Ajax.
    barcinoCommande.init();

    // Suivi de commande — hors Barba, prend la main sur la soumission du formulaire.
    barcinoSuivi.init();

    // Modal newsletter — globale (la modal est dans le footer sur toutes les pages)
    _initNewsletterModal();

    // Accordéons du footer — interception avant Barba
    _initFooterAccordions();

    // Champ téléphone avec sélecteur de pays — global (pages compte hors Barba)
    barcinoPhone.init();

    // Sync CSRF — global
    // Après tout fetch AJAX, CI peut émettre un Set-Cookie qui renouvelle le token.
    // On synchronise les hidden inputs csrf_barcino avec la valeur courante du cookie
    // juste avant chaque soumission de formulaire, pour éviter le mismatch CSRF.
    document.addEventListener('submit', (e) => {
        const match = document.cookie.match(/csrf_cookie_barcino=([^;]+)/);
        if (!match) return;
        const token = decodeURIComponent(match[1]);
        const form  = e.target.closest('form') || e.target;
        form.querySelectorAll('input[name="csrf_barcino"]').forEach(input => {
            input.value = token;
        });
    }, true); // capture phase — avant que le form parte

    // Toggle visibilité mot de passe — global (pages compte hors Barba)
    document.querySelectorAll('[data-toggle-password]').forEach(btn => {
        const input = btn.closest('.__field__wrap')?.querySelector('[data-password-input]');
        if (!input) return;
        btn.addEventListener('click', () => {
            const isHidden = input.type === 'password';
            input.type = isHidden ? 'text' : 'password';
            const icon = btn.querySelector('svg use, svg');
            btn.setAttribute('aria-pressed', String(isHidden));
        });
    });

    // Toggle des panneaux d'édition inline — "Mes informations" (hors Barba)
    // Le bouton bascule son libellé Modifier <-> Annuler selon l'état du panneau
    document.querySelectorAll('[data-edit-toggle]').forEach(btn => {
        const key   = btn.getAttribute('data-edit-toggle');
        const panel = document.querySelector(`[data-edit-panel="${key}"]`);
        if (!panel) return;
        btn.addEventListener('click', () => {
            panel.hidden = !panel.hidden;
            btn.textContent = panel.hidden ? btn.dataset.labelEdit : btn.dataset.labelCancel;
        });
    });

    // Mes préférences : sauvegarde immédiate au changement d'un choix Oui/Non.
    document.querySelectorAll('[data-preference-input]').forEach(input => {
        input.addEventListener('change', () => {
            const form = input.closest('[data-preference-form]');
            if (form) form.requestSubmit();
        });
    });

    // Copie générique vers le presse-papiers (code de parrainage, coupon, numéro de suivi…).
    document.querySelectorAll('[data-copy]').forEach(button => {
        button.addEventListener('click', async () => {
            await navigator.clipboard.writeText(button.dataset.copy);
            const label = button.querySelector('span');
            if (!label) return;
            label.textContent = button.dataset.labelSuccess;
            window.setTimeout(() => {
                label.textContent = button.dataset.labelDefault;
            }, 1500);
        });
    });

    document.querySelectorAll('[data-share-referral]').forEach(button => {
        button.addEventListener('click', async () => {
            const shareData = {
                title: button.dataset.shareTitle,
                text: button.dataset.shareText,
                url: button.dataset.shareReferral,
            };
            if (navigator.share) {
                await navigator.share(shareData);
                return;
            }
            await navigator.clipboard.writeText(shareData.url);
        });
    });

    // Détail commande : remet chaque variante disponible dans le panier courant,
    // puis ouvre directement le tunnel de commande avec le panier rempli.
    document.querySelectorAll('[data-order-rebuy]').forEach(button => {
        button.addEventListener('click', async () => {
            const items = JSON.parse(button.dataset.orderRebuy || '[]');
            if (!items.length) return;

            button.classList.add('is-loading');
            button.setAttribute('disabled', 'true');

            await Promise.all(items.map(item => barcinoCart.add(item.variant_id, item.quantity, { silent: true })));

            const lang = document.documentElement.lang === 'en' ? 'en' : 'fr';
            const checkoutSlug = lang === 'en' ? 'order' : 'commande';
            // step=details : saute l'étape "Qui va là ?" pour arriver direct sur les
            // coordonnées, panier déjà visible dans le récap (voir _get_checkout_step()).
            window.location.href = `/${lang}/${checkoutSlug}?step=details`;
        });
    });

    // Mobile "Mon compte" : on atterrit par défaut sur le hub (menu — Mes informations,
    // Mes commandes…), qui n'existe qu'en mobile (desktop affiche direct le contenu).
    // Cliquer sur la section déjà active (ex. "Mes informations") affiche son contenu ;
    // le bouton Retour ramène au hub. Aucun rechargement, une seule page/URL.
    const compteLayout = document.querySelector('.bc-compte-dashboard__layout');
    if (compteLayout) {
        const activeItem = compteLayout.querySelector('.bc-compte-sidebar__item.is-active');
        if (activeItem) {
            activeItem.addEventListener('click', (e) => {
                e.preventDefault();
                compteLayout.classList.add('is-content-visible');
            });
        }
        compteLayout.querySelectorAll('.bc-compte-dashboard__back').forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                compteLayout.classList.remove('is-content-visible');
            });
        });
    }

    // Mega-menu Swiper — uniquement si >5 catégories (PHP ajoute data-mega-swiper)
    const megaSwiperEl = document.querySelector('[data-mega-swiper]');
    if (megaSwiperEl) {
        import('swiper').then(({ default: Swiper }) => {
            import('swiper/modules').then(({ Navigation }) => {
                new Swiper(megaSwiperEl, {
                    modules: [Navigation],
                    slidesPerView: 5.3,
                    spaceBetween: 12,
                });
            });
        });
    }

    let namespace = $(".barba-container").data("barba-namespace");
    //alert(namespace);
    $(".nav > li[data-m=" + namespace + "]").addClass("_activ");
    $("._nav_mobile > ._item[data-m=" + namespace + "]").addClass("_activ");


    // Initialisation du scroll — jamais sur le flux e-commerce (panier, tunnel
    // de commande, confirmation) : ces pages sont hors Barba (voir CLAUDE.md),
    // et Lenis y perturbait le centrage des overlays position:fixed (modale
    // "paiement en cours") en plus de désactiver le pointer-events des iframes
    // Stripe pendant le scroll fluide.
    const isEcommerceFlowPage = Boolean(document.querySelector('.bc-checkout, .bc-panier, .bc-order-confirmation'));
    if (!isEcommerceFlowPage) {
        scroll.show();
    }

    // Initialisation du modal
    modal.init();

    if (!isEcommerceFlowPage) {
        scroll.update();
    }


    // Switcher de langue — rechargement complet, indépendant de Barba
    document.addEventListener('click', (event) => {
        const el = event.target.closest('[data-lang-switch]');
        if (!el) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.href = el.getAttribute('href');
    }, true);

    document.addEventListener("click", (event) => {
        const anchorLink = event.target.closest('a.__with_anchor');

        if (anchorLink) {
            const href = anchorLink.getAttribute('href');

            if (href && href.includes('#')) {
                transitions.anchorTarget = href.split('#')[1] || null;
            }
        }

        const el = event.target.closest('a.prevent-barba');
        if (!el) return;

        // cas download : laisser le navigateur gérer nativement
        if (el.hasAttribute('download')) {
            event.stopPropagation();
            event.stopImmediatePropagation();
            return;
        }

        // pour les autres cas, on bloque le comportement par défaut
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        // cas mailto
        if (el.href.startsWith('mailto:')) {
            window.location.href = el.href;
            return false;
        }

        // cas nouvel onglet
        if (el.target === '_blank') {
            window.open(el.href, '_blank', 'noopener');
            return false;
        }

        // cas navigation normale
        window.location.href = el.href;
        return false;
    }, true);

    // Les flux e-commerce sont volontairement hors Barba et n'ont donc aucun
    // conteneur data-barba. Ne jamais initialiser Barba sur ces pages.
    const barbaContainer = document.querySelector('[data-barba="container"]');
    if (barbaContainer) barba.init({
        prevent: ({el}) => {
            return !!(el && el.classList && el.classList.contains('prevent-barba'));
        },
        views: [
            {
                namespace: 'landing',
                afterEnter() {
                    scroll.update();
                    landing.init();
                }
            },
            {
                namespace: 'ACC',
                afterEnter() {
                    scroll.update();
                    accueil.init();
                }
            },
            {
                namespace: 'PROJ',
                afterEnter() {
                    scroll.update();
                    projets.init();
                },
                leave(data) {
                    if (typeof projets !== "undefined" && projets.destroy) {
                        projets.destroy();
                    }
                }
            },
            {
                namespace: 'ACTIVITES',
                afterEnter() {
                    scroll.update();
                    activites.init();
                },
                leave(data) {
                    if (typeof activites !== "undefined" && activites.destroy) {
                        activites.destroy();
                    }
                }
            },
            {
                namespace: 'actualite',
                afterEnter() {
                    scroll.update();
                    actualite.init();
                }
            },
            {
                namespace: 'BARCINO_HOME',
                afterEnter() {
                    scroll.update();
                    barcinoHome.init();
                },
                leave() {
                    barcinoHome.destroy();
                }
            },
            {
                namespace: 'BARCINO_DIAGNOSTIC',
                afterEnter() {
                    scroll.update();
                    barcinoDiagnostic.init();
                },
                leave() {
                    barcinoDiagnostic.destroy();
                }
            },
            {
                namespace: 'BARCINO_CATALOGUE',
                afterEnter() {
                    scroll.update();
                    barcinoCatalogue.init();
                },
                leave() {
                    barcinoCatalogue.destroy();
                }
            },
            {
                namespace: 'BARCINO_NEWS',
                afterEnter() {
                    scroll.update();
                    barcinoNews.init();
                },
                leave() {
                    barcinoNews.destroy();
                }
            },
            {
                namespace: 'BARCINO_FAQ',
                afterEnter() {
                    scroll.update();
                    barcinoFaq.init();
                },
                leave() {
                    barcinoFaq.destroy();
                }
            },
            {
                namespace: 'BARCINO_LEGAL',
                afterEnter() {
                    scroll.update();
                    barcinoLegal.init();
                },
                leave() {
                    barcinoLegal.destroy();
                }
            },
            {
                namespace: 'BARCINO_TORREFACTEURS',
                afterEnter() {
                    scroll.update();
                    barcinoTorrefacteurs.init();
                },
                leave() {
                    barcinoTorrefacteurs.destroy();
                }
            },
            {
                namespace: 'BARCINO_TORREFACTEUR_DETAIL',
                afterEnter() {
                    scroll.update();
                    barcinoTorrefacteurDetail.init();
                },
                leave() {
                    barcinoTorrefacteurDetail.destroy();
                }
            },
            {
                namespace: 'BARCINO_VISION',
                afterEnter() {
                    scroll.update();
                    barcinoVision.init();
                },
                leave() {
                    barcinoVision.destroy();
                }
            }
        ],
        transitions: [
            transitions.basicTransition
        ],
        debug: false // Ajouté pour faciliter le débogage si nécessaire
    });


    // Gestion de la redimension de la fenêtre
    $(window).on("debouncedresize", function () {
        common.getWINDOW();
        if (common.$windowW <= 768 && mobile.state === false) {
            location.reload();
            mobile.state = true;
        } else if (common.$windowW > 768 && mobile.state === true) {
            location.reload();
            mobile.state = false;
        }
    });
});
